import enviro from 'enviro';
export const getDefaultClientOptions = () => {
  const hublet = enviro.getHublet();
  return {
    environment: `hubspot-${hublet}`,
    fallbackHosts: [`hubspot-${hublet}-a-fallback.ably-realtime.com`, `hubspot-${hublet}-b-fallback.ably-realtime.com`, `hubspot-${hublet}-c-fallback.ably-realtime.com`, `hubspot-${hublet}-d-fallback.ably-realtime.com`, `hubspot-${hublet}-e-fallback.ably-realtime.com`]
  };
};